import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  BaseBackResponse,
  Intervention,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}TechnicalIntervention/PlanningComment`;

interface CreatePlanningCommentCommandPayload {
  sellerId: string;
  assignedToIds: string[];
  description: string;
  endDateTimeUtc: Date;
  startDateTimeUtc: Date;
}

const createPlanningCommentCommand = async (
  payload: CreatePlanningCommentCommandPayload,
): Promise<BaseBackResponse | BackResponseFailure> => {
  try {
    const response = await apiCall<BackResponse<Intervention>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: payload,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default createPlanningCommentCommand;
